
import { Component, Vue, Prop } from "vue-property-decorator";
import tigermaster from "fdtigermaster-client-sdk";
import ICarouselBanner from "fdtigermaster-client-sdk/lib/src/Entity/ICarouselBanner";

@Component
export default class Carousel extends Vue {
  @Prop() device: number;

  // data
  isActive = 0;
  timer = 0;
  index = 0;
  show = 0;
  imgs: ICarouselBanner[] = [];
  clicked = null;
  transitionName = "slide-next";
  imagesReady = false;
  isPaused = false;
  prefersReducedMotion = false;
  isDocumentVisible = true;
  motionMediaQuery: MediaQueryList | null = null;

  // hook
  mounted(): void {
    this.isDocumentVisible = !document.hidden;
    this.motionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.prefersReducedMotion = this.motionMediaQuery.matches;
    this.isPaused = this.prefersReducedMotion;
    this.motionMediaQuery.addListener(this.handleMotionPreferenceChange);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.getAd();
  }

  beforeDestroy(): void {
    this.clearTimer();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.motionMediaQuery?.removeListener(this.handleMotionPreferenceChange);
  }

  get playbackLabel(): string {
    return this.isPaused ? "播放首頁輪播" : "暫停首頁輪播";
  }

  // methods
  changeShow(index: number): void {
    if (index === this.show) {
      this.restartTimer();
      return;
    }
    this.transitionName = index > this.show ? "slide-next" : "slide-prev";
    this.show = index;
    this.isActive = index;
    this.restartTimer();
  }
  async getAd(): Promise<void> {
    const res = await tigermaster.carouselBanner.get(this.device);
    this.imgs = res as unknown as ICarouselBanner[];
    this.show = 0;
    this.isActive = 0;
    if (this.imgs.length === 0) {
      this.imagesReady = true;
    }
    this.restartTimer();
  }
  onImageLoad(index: number): void {
    if (index === 0) {
      this.imagesReady = true;
    }
  }
  next(restartTimer = true): void {
    if (this.imgs.length === 0) {
      return;
    }
    this.transitionName = "slide-next";
    this.show = (this.show + 1) % this.imgs.length;
    this.isActive = this.show;
    if (restartTimer) {
      this.restartTimer();
    }
  }
  prev(): void {
    if (this.imgs.length === 0) {
      return;
    }
    this.transitionName = "slide-prev";
    this.show = (this.show - 1 + this.imgs.length) % this.imgs.length;
    this.isActive = this.show;
    this.restartTimer();
  }
  togglePlayback(): void {
    this.isPaused = !this.isPaused;
    this.restartTimer();
  }
  handleVisibilityChange(): void {
    this.isDocumentVisible = !document.hidden;
    this.restartTimer();
  }
  handleMotionPreferenceChange(event: MediaQueryListEvent): void {
    this.prefersReducedMotion = event.matches;
    if (event.matches) {
      this.isPaused = true;
    }
    this.restartTimer();
  }
  clearTimer(): void {
    window.clearTimeout(this.timer);
    this.timer = 0;
  }
  restartTimer(): void {
    this.clearTimer();
    if (this.imgs.length > 1 && !this.isPaused && this.isDocumentVisible) {
      this.timer = window.setTimeout(() => {
        this.next(false);
        this.restartTimer();
      }, 5000);
    }
  }
}
